import { Color } from "three";

// eine Farbpalette für eine Aufzählung von Objekten,
// die gut unterscheidbar ist und nicht mit anderen wichtigen
// Farben wie Fehler wie Fehlerfarbe oder Selektionsfarbe kollidiert
export const lowDiscrepancyColorSequence = [
  "#0000ff",
  "#ff00ff",
  "#ffff00",
  "#00ff00",
  "#ff9900",
  "#cb7900",
  "#00cb00",
].map((c) => new Color(c));
